import React from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import RegisterComp from "../../components/LoginRegister/RegisterComp";
export default function Registration() {

  return (
    <>
      <Header />
      <RegisterComp />
      <Footer />
    </>
  );
}
